import StockOutStatus from './stockoutStatus';
import InventoryPolicy from './inventoryPolicy';

export const checkVariantsAcceptingOrders = variants => {
  const variantsAcceptingOrders = variants.filter(
    variant => variant.inventory_policy === InventoryPolicy.Continue,
  );

  const containsVariants = variantsAcceptingOrders.length !== 0;

  if (!containsVariants) {
    return StockOutStatus.None;
  }

  const containsVariantsWithSameLenght =
    variantsAcceptingOrders.length === variants.length;

  return containsVariantsWithSameLenght
    ? StockOutStatus.All
    : StockOutStatus.Some;
};
